import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import {newRoute, editRoute, detailRoute} from "../../../shared/services/data.service";
import { manutencoesRoute } from "../../shared/data.service";
import {
    ordensServicoRoute, ordensServicoItemsServicoRoute,
    ordensServicoItemsMaterialRoute
} from "./data.service";

@Injectable()
export class OrdemServicoNavigationService {
    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToDetail(objectId: number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + detailRoute;
        this._authService.navigateTo(router, objectId);
    }

    //itens: materiais e servicos
    goToNewServico(osId: number, tipo :number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + ordensServicoItemsServicoRoute + '/' + newRoute;
        this._authService.navigateTo(router, [osId, tipo]);
    }

    goToEditServico(osId: number, tipo :number, objectId: number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + ordensServicoItemsServicoRoute + '/' + editRoute;
        this._authService.navigateTo(router, [osId, tipo, objectId]);
    }

    goToNewMaterial(osId: number, tipo :number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + ordensServicoItemsMaterialRoute + '/' + newRoute;
        this._authService.navigateTo(router, [osId, tipo]);
    }

    goToEditMaterial(osId: number, tipo :number, objectId: number) {
        var router: string = manutencoesRoute + '/' + ordensServicoRoute + '/' + ordensServicoItemsMaterialRoute + '/' + editRoute;
        this._authService.navigateTo(router, [osId, tipo, objectId]);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/shared/ordem-servico-navigation.service.ts
 **/